/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 18/05/22
 */

import {
    Center,
    FormControl,
    FormErrorMessage,
    FormLabel,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
} from '@chakra-ui/react';
import { useField } from 'formik';
import React from 'react';

const WorkloadNumberField = ({
    name,
    label,
    prefix,
    onChange,
}: {
    name: string;
    label: string;
    prefix?: string;
    onChange?: (valueAsString: string, name: string) => void;
}) => {
    const [field, meta, helpers] = useField(name);

    return (
        <FormControl display="contents" isInvalid={!!meta.error}>
            <FormLabel whiteSpace={'nowrap'} m={0}>
                {label}
            </FormLabel>
            <NumberInput
                value={meta.value || ''}
                onBlur={field.onBlur}
                onChange={(valueAsString) => {
                    helpers.setValue(valueAsString);
                    if (onChange) {
                        onChange(valueAsString, name);
                    }
                }}
                isRequired
                isInvalid={!!meta.error}
                step={1}
                min={0}
                max={100}
                style={{ display: 'flex' }}
            >
                {prefix && (
                    <Center
                        width="var(--chakra-sizes-10)"
                        height="100%"
                        position="absolute"
                        left={0}
                        background={'gray.200'}
                        borderLeftRadius="md"
                        fontWeight="bold"
                    >
                        {prefix}
                    </Center>
                )}
                <NumberInputField paddingInlineStart={prefix ? 'var(--chakra-space-14)' : undefined} />
                <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                </NumberInputStepper>
            </NumberInput>
            <FormErrorMessage color="red.600" gridColumn={'span 2'} justifyContent="flex-end">
                {meta.error}
            </FormErrorMessage>
        </FormControl>
    );
};

export default WorkloadNumberField;
